let APP = window.APP || {};
import {Exposure} from "@js/libs/exposure";
APP.Exposure = Exposure;
